import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getJobOpenings, recruitmentAnalytics, submitJobOpening, deleteJobOpening, approveJobOpening, publishJobOpening, 
    getLoggedInUser} from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from "../../utils/alerts";


export default function JobOpenings() {
    const [loading, setLoading] = useState(false);
    const [a_loading, setALoading] = useState(false);
    const [jobs, setJobs] = useState(null);
    const [analytics, setAnalytics] = useState(null);
    const history = useHistory();
    const [profile, setProfile] = useState("");
    const TOKEN = localStorage.getItem("kloka:token:data");

    useEffect(()=>{
        if(TOKEN){
            getLoggedInUser(TOKEN).then((res) => {
                setProfile(res.data.data);
            });
        }
    }, [TOKEN]);
    
    useEffect(() => {
        setLoading(true)
        getJobOpenings()
            .then((res) => {
                setJobs(res?.data?.data);
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        setALoading(true)
        recruitmentAnalytics()
            .then((res) => {
                setAnalytics(res?.data?.data);
                setTimeout(() => {
                    setALoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setTimeout(() => {
                    setALoading(false)
                }, 3500);
            });
    }, []);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    const navigateBySec = (path, id, sec) => {
        history.push(`${path}/${id}/${sec}`);
    };


    const handleSubmit = async (item, id) => {
        if (window.confirm("Note: Click OK to continue.")) {
            const data = { ...item, id}
            if(data.status === "draft"){
                setLoading(true);
                submitJobOpening(data, id)
                    .then((res) => {
                        if(res.data.success){
                            alertSuccess(res.data.message)
                            window.location.reload()
                        } else {
                            alertError(res.data.message)
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        alertError(err?.response?.data?.error);
                        setLoading(false);
                    });
            }
        } else {
            alert("Submission was canceled!");
        }
    };

    const handleDelete = (id) => {
        if (window.confirm("Note: This is an irreversible action. Click OK to continue.")) {
            deleteJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                });
        } else {
            alert("Deletion was canceled!");
        }
    };

    const handleApprove = (id) => {
        if (window.confirm("Note: This is an irreversible action. Click OK to continue.")) {
            approveJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                });
        } else {
            alert("Job Opening approval was canceled!");
        }
    };

    const handlePublish = (id) => {
        if (window.confirm("Note: This is an irreversible action. Click OK to continue.")) {
            publishJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        setTimeout(() => {
                            history.push(`/recruitment/job/${id}/applicants`);
                        }, 3500);
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                });
        } else {
            alert("Job Opening publishing was canceled!");
        }
    };

    const isTeamHead = (profile && profile.team?.team_head) ? profile.team?.team_head === profile._id : false;
    const isRecruitmentTeamHead = (profile && profile.team?.team_head) ? (isTeamHead && profile.team?.team_name === "Recruitment") : false;

    return (
        <>
            <div className="spur-card-menu"><Link to="/recruitment/job/post" className="pull-right btn topbtn btn-primary">CREATE JOB OPENING</Link></div>

            <h1 className="dash-title">Recruitment</h1>

            <div className="row dash-row">
                {((!a_loading || a_loading) && analytics && analytics) ? 
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="row">
                        {analytics && analytics.map((row, i)=> 
                            <div className="col-md-3 col-sm-6 col-12" key={i}>
                                <div className="dashbox">
                                    <h4>{row.name && row.name}</h4>
                                    <p>{row.count && row.count}</p>
                                    <span>{row.name && row.name}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div> : null }

                <div className="col-md-12 col-sm-12 col-12">
                    {(!loading && jobs && jobs) ? 
                        <div>
                            {(jobs && jobs.length > 0) ?
                            <section>
                                {jobs && jobs.map((item, index) => 
                                    <div className="card spur-card job_card" key={index}>
                                        <div className="job_card_header">
                                            {item.jobTitle && item.jobTitle}
                                            
                                            <div className="spur-card-menu pull-right">
                                                <span className="btn myybtn badge badge-danger" style={{color:'#fff', fontSize: 12, 
                                                backgroundColor:'#303030', borderRadius: 7, marginRight: 10, fontWeight: 300, }}>{item.status && item.status}</span>
                                            </div>
                                        </div>
                                        <div className="job_card_body">
                                            <div className="col-12">
                                                <span className="job_card_span">{item.industry}</span>
                                                <span className="job_card_span">{item.location && item.location}</span>
                                                <span className="job_card_span">Days Online: {item.days_online && item.days_online} days</span>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <button onClick={() => navigateById("/recruitment/job/overview", item._id)} 
                                                    className='btn btn-primary job_card_btn'>
                                                    Job Overview 
                                                </button>
                                                <button className='btn btn-primary job_card_btn' disabled >
                                                    All Candidates <span>(0)</span>
                                                </button>
                                                <button className='btn btn-primary job_card_btn' disabled >
                                                    Shortlisted <span>(0)</span>
                                                </button>
                                                <button className='btn btn-primary job_card_btn' disabled >
                                                    Scheduled for Interview <span>(0)</span>
                                                </button>
                                                <button className='btn btn-primary job_card_btn'disabled >
                                                    Hired <span>(0)</span>
                                                </button>
                                                <button className='btn btn-primary job_card_btn'disabled >
                                                    Rejected <span>(0)</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="job_card_footer">
                                            <div className="col-12">
                                                <button onClick={() => navigateBySec("/recruitment/job", item._id, "edit")} 
                                                    className='btn btn-primary job_card_btn job_card_btn_primary'
                                                >
                                                    <i className="fa fa-pencil"></i> Edit Job 
                                                </button>

                                                {(item.status === "draft") ?
                                                <button onClick={() =>  handleSubmit(item, item._id) } 
                                                    className='btn btn-primary job_card_btn job_card_btn_primary'
                                                >
                                                    <i className="fa fa-pencil"></i> Submit Job 
                                                </button> : null}

                                                {isRecruitmentTeamHead ?
                                                <button onClick={() => handleDelete(item._id)} 
                                                    className='btn btn-danger job_card_btn job_card_btn_danger'
                                                >
                                                    <i className="fa fa-trash"></i> Delete This Job
                                                </button> : null }

                                                {(item.status === "submitted" && isRecruitmentTeamHead) ?
                                                <button onClick={() => handleApprove(item._id)} 
                                                    className='btn btn-success job_card_btn job_card_btn_green pull-right mr-0'
                                                >
                                                    <i className="fa fa-check-circle"></i> Approve This Job
                                                </button> : null }

                                                {(item.status === "approved" && isRecruitmentTeamHead) ?
                                                <button onClick={() => handlePublish(item._id)} 
                                                    className='btn btn-success job_card_btn job_card_btn_success pull-right mr-0'
                                                >
                                                    <i className="fa fa-external-link"></i> Publish This Job
                                                </button> : null }

                                                {(item.status === "published") ?
                                                <a href={`${item.jobUrl}`} target="_blank" rel="noreferrer" 
                                                    className='btn btn-success job_card_btn job_card_btn_success pull-right mr-0'
                                                >
                                                    <i className="fa fa-external-link"></i> View Online
                                                </a> : null }
                                            </div>
                                        </div>
                                    </div> 
                                )}
                            </section>
                            : 
                            <div className="alert alert-danger myerror d-block">
                                There are no job openings yet.
                            </div> 
                            }
                        </div> 
                    : <Loader /> }
                </div> 
            </div>
        </>
    );
}
